var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinishImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 207,
    viewBox: "0 0 248 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0312 102.683H60.8989L68.8487 69.4177H87.9811L80.0312 102.683Z",
    fill: "#3859E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6732 102.683H63.5409L71.4907 69.4177H90.623L82.6732 102.683Z",
    fill: "#1C2472"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9992 92.4089L65.3846 94.9794L83.9024 97.542L86.3528 87.2758L65.9992 92.4089Z",
    fill: "#111A56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.159 0.5H7.07773C5.01468 0.5 3.34225 2.17269 3.34225 4.23607V90.1097C3.34225 92.1731 5.01468 93.8458 7.07773 93.8458H136.159C138.222 93.8458 139.895 92.1731 139.895 90.1097V4.23607C139.895 2.17269 138.222 0.5 136.159 0.5Z",
    fill: "#3859E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.462 1H139.543C141.33 1 142.779 2.44876 142.779 4.23607V90.1097C142.779 91.897 141.33 93.3458 139.543 93.3458H10.462C8.67518 93.3458 7.22653 91.897 7.22653 90.1097V4.23607C7.22653 2.44876 8.67518 1 10.462 1Z",
    fill: "url(#paint0_linear_1866_503)",
    stroke: "url(#paint1_linear_1866_503)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.612 4.37976H12.4016V89.974H137.612V4.37976Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.329 6.61501H18.6753C17.4542 6.61501 16.4643 7.60505 16.4643 8.82632V77.4167C16.4643 78.638 17.4542 79.628 18.6753 79.628H128.329C129.55 79.628 130.54 78.638 130.54 77.4167V8.82632C130.54 7.60505 129.55 6.61501 128.329 6.61501Z",
    stroke: "#B3C7FB",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.329 6.61501H18.6753C17.454 6.61501 16.4643 7.60491 16.4643 8.82632V15.3086H130.54V8.82632C130.54 7.60491 129.55 6.61501 128.329 6.61501Z",
    fill: "#B3C7FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.36 11.5725H22.7061C21.485 11.5725 20.4951 12.5625 20.4951 13.7838V82.3742C20.4951 83.5954 21.485 84.5855 22.7061 84.5855H132.36C133.581 84.5855 134.571 83.5954 134.571 82.3742V13.7838C134.571 12.5625 133.581 11.5725 132.36 11.5725Z",
    fill: "white",
    stroke: "#DCE4FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.36 11.5725H22.7061C21.4849 11.5725 20.4951 12.5624 20.4951 13.7838V20.2581H134.571V13.7838C134.571 12.5624 133.581 11.5725 132.36 11.5725Z",
    fill: "#DCE4FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.84 43.16L68.16 56.84M68.16 43.16L81.84 56.84",
    stroke: "#C1C7D1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 69C85.4934 69 94 60.4934 94 50C94 39.5066 85.4934 31 75 31C64.5066 31 56 39.5066 56 50C56 60.4934 64.5066 69 75 69Z",
    stroke: "#C1C7D1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6548 15.9153C27.6548 16.8333 26.9125 17.5678 26.0025 17.5678C25.0926 17.5678 24.3503 16.8253 24.3503 15.9153C24.3503 15.0052 25.0926 14.2628 26.0025 14.2628C26.9125 14.2628 27.6548 15.0052 27.6548 15.9153Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8646 15.9153C33.8646 16.8333 33.1223 17.5678 32.2123 17.5678C31.3024 17.5678 30.5601 16.8253 30.5601 15.9153C30.5601 15.0052 31.3024 14.2628 32.2123 14.2628C33.1223 14.2628 33.8646 15.0052 33.8646 15.9153Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0744 15.9153C40.0744 16.8333 39.3321 17.5678 38.4222 17.5678C37.5123 17.5678 36.77 16.8253 36.77 15.9153C36.77 15.0052 37.5123 14.2628 38.4222 14.2628C39.3321 14.2628 40.0744 15.0052 40.0744 15.9153Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5716 102.683H100.88C103.075 102.683 104.855 104.463 104.855 106.659V107.377H46.5716V102.683Z",
    fill: "#1C2472"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5716 102.683H57.2193C59.4143 102.683 61.1942 104.463 61.1942 106.659V107.377H46.5716V102.683Z",
    fill: "#3859E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3629 205.712H20.0801V108.958H28.7483L22.3629 205.712Z",
    stroke: "url(#paint2_linear_1866_503)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.26 205.712H227.535V108.958H218.874L225.26 205.712Z",
    stroke: "url(#paint3_linear_1866_503)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.617 107.185H-0.00210571V111.608H247.617V107.185Z",
    fill: "#6E92EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.444 145.017L149.545 203.677C149.337 204.451 149.92 205.217 150.726 205.217C151.261 205.217 151.732 204.866 151.891 204.355L170.265 145.009H165.444V145.017Z",
    stroke: "url(#paint4_linear_1866_503)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.4 145.017L218.3 203.677C218.507 204.451 217.925 205.217 217.118 205.217C216.584 205.217 216.113 204.866 215.953 204.355L197.579 145.009H202.4V145.017Z",
    stroke: "url(#paint5_linear_1866_503)",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M185.934 145.017L190.06 203.916C190.108 204.619 189.549 205.225 188.839 205.225H188.751C188.128 205.225 187.602 204.754 187.538 204.14L181.113 145.025H185.934V145.017Z",
    stroke: "url(#paint6_linear_1866_503)",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.299 124.636C162.299 124.636 131.41 130.217 131.41 139.964C131.41 149.711 160.855 149.472 183.691 149.703C208.929 149.959 228.245 141.696 231.39 121.635C235.995 92.2332 228.931 45.261 204.938 39.569C155.387 27.81 162.299 124.636 162.299 124.636Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.386 79.5003L106.467 77.7759C106.467 77.7759 102.883 78.8616 101.351 78.67C99.8181 78.4705 98.2776 77.3927 97.3916 76.5146C96.5056 75.6365 95.5638 74 95.8112 73.7525C96.7451 72.8185 99.9937 75.1495 100.76 75.0298C101.526 74.91 102.612 74.3672 103.921 74.0239C106.459 73.3693 108.231 74.9579 108.231 74.9579L112.701 76.9776",
    fill: "#F5D0C0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.299 47.6559C169.299 47.6559 158.277 49.4281 150.694 58.928C142.856 68.7391 136.359 78.9095 136.359 78.9095L109.364 75.4289L107.297 78.1432C107.297 78.1432 133.804 97.9411 145.594 94.1492C157.423 90.3413 169.379 70.0962 169.379 70.0962",
    fill: "#AF45EE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.359 78.9095C136.359 78.9095 142.321 78.702 143.359 81.8074",
    stroke: "#1C2472",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.912 199.757C121.912 199.757 113.587 204.882 114.034 205.992C114.632 207.485 124.881 205.273 125.895 204.06C126.789 202.998 124.609 199.438 124.609 199.438L122.502 198.927",
    fill: "#3859E0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M120.658 196.069L121.209 200.348C121.209 200.348 121.784 200.507 122.877 200.284C123.979 200.06 124.609 199.454 124.609 199.454L126.876 191.646",
    fill: "#F5D0C0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M164.997 108.016C164.997 108.016 129.015 111.337 120.092 123.096C111.136 134.903 120.866 197.889 120.866 197.889C122.295 197.937 125.264 197.218 125.264 197.218C125.264 197.218 136.095 173.804 136.095 156.305C136.095 147.428 135.217 141.824 134.587 138.926C134.339 137.792 135.313 136.763 136.462 136.938C145.37 138.343 175.286 142.495 181.639 136.14C190.619 127.159 185.766 108 185.766 108",
    fill: "#1C2472"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M175.398 198.959C175.398 198.959 168.022 204.283 168.573 205.345C169.307 206.774 179.309 203.645 180.211 202.343C181.001 201.202 178.367 197.578 178.367 197.578L176.363 197.546",
    fill: "#3859E0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M174.104 197.027L175.398 198.951C175.398 198.951 175.781 199.158 176.858 198.839C177.928 198.52 178.359 197.57 178.359 197.57L177.09 190.6",
    fill: "#F5D0C0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M184.952 112.494C184.952 112.494 139.99 115.073 135.09 124.581C128.305 137.753 174.104 197.027 174.104 197.027C174.104 197.027 176.499 197.027 178.048 195.63C178.359 195.119 173.578 168.2 167.767 154.573C164.622 147.212 160.392 142.934 158.923 141.6C158.756 141.449 158.875 141.177 159.099 141.193C164.742 141.608 202.248 143.476 210.717 136.148C222.61 125.858 214.844 108.008 214.844 108.008",
    fill: "#1C2472"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.454 136.459C136.454 136.459 132.926 125.818 136.263 122.697C139.599 119.575 152.841 113.46 175.924 112.51",
    stroke: "#374AAA",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M163.337 58.5208C160.264 69.5294 158.428 102.571 157.502 103.489C156.584 104.407 155.355 105.349 155.355 108.279C155.355 111.209 167.328 112.806 175.845 113.867C184.361 114.929 208.227 113.891 214.157 111.105C217.35 109.604 215.753 107.385 215.753 107.385C215.753 107.385 214.995 106.587 212.026 90.6286C206.662 61.7699 196.996 50.3781 196.996 50.3781L187.49 45.0933L169.299 47.6479L163.337 58.5128V58.5208Z",
    fill: "#AF45EE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M162.978 58.9279C159.634 65.7135 159.769 82.7254 159.769 82.7254",
    stroke: "#1C2472",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239.763 51.4239L240.673 46.7298C240.673 46.7298 244.48 46.0194 245.661 45.0215C246.842 44.0236 247.425 42.4829 247.537 41.2375C247.617 40.2875 246.89 37.6371 246.539 37.6451C245.709 37.6691 244.887 41.3253 244.177 41.6446C243.466 41.964 240.928 41.964 239.691 42.5228C238.454 43.0736 237.855 45.6441 237.855 45.6441L236.019 50.3302",
    fill: "#F5D0C0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.585 70.4076C208.043 79.8675 221.58 95.9693 231.589 91.6585C241.782 87.2678 240.337 48.4542 240.337 48.4542L237.193 47.3366C232.124 56.9002 224.773 70.2479 224.773 70.2479C224.773 70.2479 216.145 54.5532 206.558 49.8911C200.396 46.8895 194.426 44.8299 187.482 45.1093",
    fill: "#AF45EE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M220.439 80.9771C220.535 75.9318 224.781 70.2399 224.781 70.2399",
    stroke: "#1C2472",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M200.021 71.8525C200.021 71.8525 205.92 77.9436 210.206 82.1027",
    stroke: "#1C2472",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M165.205 27.4667C164.534 28.8957 164.415 30.5722 164.878 32.073C165.341 33.5818 166.378 34.899 167.735 35.6973C168.222 35.9847 168.821 36.2082 169.331 35.9687C169.778 35.7611 170.01 35.2582 170.169 34.7872C171.247 31.5461 170.433 27.7462 168.126 25.2315",
    fill: "#4C4C4C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.621 34.1406C168.406 33.957 168.062 33.9969 167.823 34.1565C167.583 34.3162 167.448 34.5876 167.344 34.8511C167.224 35.1305 167.136 35.4418 167.176 35.7452C167.208 35.9767 167.32 36.1922 167.44 36.3918C167.831 37.0304 168.39 37.5573 169.044 37.9086C169.228 38.0044 169.411 38.0922 169.619 38.1161C170.273 38.2039 170.84 37.693 171.303 37.222",
    fill: "#EDB5A2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M175.118 37.8367L175.892 46.0513L169.81 47.592C169.81 47.592 174.12 51.6793 179.42 51.3999C187.378 50.9768 189.869 45.1093 189.869 45.1093L184.72 45.0215L180.402 32.2486",
    fill: "#F5D0C0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M181.775 36.28L180.41 32.2406L175.118 37.8367L175.677 43.7202C178.447 43.2093 180.634 40.9102 181.304 37.7808C181.416 37.2779 181.647 36.7989 181.775 36.288V36.28Z",
    fill: "#EDB5A2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M166.418 28.9436C167.248 31.5301 168.086 34.1246 169.236 36.5914C170.417 39.122 172.5 41.8123 175.286 41.6127C178.614 41.3812 180.849 39.5132 182.014 36.4796C183.22 33.3423 183.363 29.5503 181.464 26.6525C180.083 24.537 177.84 22.9404 175.382 22.3576C172.923 21.7748 165.476 25.2315 166.418 28.9516",
    fill: "#F5D0C0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M182.845 34.0128C182.286 34.3561 181.567 33.2305 181.272 31.7297C181.136 31.0272 180.905 30.3806 180.801 29.678C180.602 28.2571 179.676 27.0995 178.431 26.4289C176.802 25.5508 175.406 25.8701 173.745 26.5407C172.205 27.1554 170.736 27.9377 169.164 28.4806C167.599 29.0234 165.883 29.3108 164.279 28.9037C162.978 28.5764 161.541 27.7142 160.703 26.6445C159.713 25.3752 160.065 24.05 161.19 23.0362C161.948 22.3576 162.858 21.7828 163.289 20.8568C163.92 19.4997 163.321 17.7753 164.079 16.4901C164.686 15.4682 165.979 15.0611 167.168 15.109C167.815 15.1329 168.453 15.2686 169.052 15.5081C169.794 15.8035 170.704 16.4501 171.542 16.2745C172.101 16.1548 172.476 15.6119 173.027 15.4203C174.312 14.9653 176.124 15.109 176.946 16.3224C177.233 16.7455 177.377 17.2564 177.704 17.6556C180.075 20.5135 183.084 18.5337 184.385 23.2677C184.952 25.3353 184.225 27.1315 184.417 29.5982C184.648 32.5759 183.635 33.5339 182.837 34.0208L182.845 34.0128Z",
    fill: "#4C4C4C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M181.041 32.5919C180.817 30.636 183.643 30.173 183.842 32.6158C184.026 34.9229 182.078 37.6052 181.049 35.2742",
    fill: "#F5D0C0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 31.8734C178.838 32.2167 178.526 32.4721 178.183 32.4322C177.84 32.3923 177.585 32.0889 177.624 31.7457C177.656 31.4024 177.968 31.1469 178.311 31.1869C178.654 31.2268 178.91 31.5301 178.87 31.8734Z",
    fill: "#1C2472"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.876 29.3827C176.403 29.1512 176.954 28.9356 177.529 28.8797C178.103 28.8239 178.718 28.9596 179.149 29.3428",
    fill: "#1C2472"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M169.85 33.6776C169.97 34.0049 170.329 34.1725 170.656 34.0528C170.984 33.933 171.151 33.5738 171.032 33.2465C170.912 32.9192 170.553 32.7515 170.225 32.8713C169.898 32.991 169.731 33.3503 169.85 33.6776Z",
    fill: "#1C2472"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.207 30.3007C170.632 30.3007 170.042 30.3327 169.499 30.5243C168.956 30.7158 168.445 31.0831 168.214 31.6099",
    fill: "#1C2472"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.057 32.7435C174.009 32.6158 173.929 32.4402 173.801 32.3763C173.689 32.3204 173.394 32.3444 173.354 32.4961C173.338 32.552 173.354 32.6158 173.354 32.6797C173.514 33.6935 173.49 34.7792 173.075 35.7372C173.003 35.8968 172.923 36.0884 173.003 36.2481C173.075 36.3918 173.242 36.4477 173.394 36.4716C173.881 36.5594 174.512 36.6233 174.935 36.3678C175.07 36.288 175.206 36.1763 175.222 36.0086C175.262 35.6254 174.232 33.1986 174.057 32.7435Z",
    fill: "url(#paint7_linear_1866_503)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M179.812 34.5238C179.46 33.5977 178.495 33.3822 177.688 33.8771C177.513 33.9809 177.353 34.1326 177.249 34.3242C177.01 34.7792 177.146 35.4019 177.417 35.7771C177.656 36.1124 177.936 36.2242 178.303 36.3199C178.766 36.4397 179.404 36.2641 179.708 35.833C179.955 35.4737 179.963 34.9469 179.812 34.5317V34.5238Z",
    fill: "#F2AAA2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M172.468 36.0645C172.117 35.1385 171.151 34.9229 170.345 35.4179C170.169 35.5216 170.01 35.6733 169.906 35.8649C169.667 36.32 169.802 36.9426 170.074 37.3178C170.313 37.6531 170.593 37.7649 170.96 37.8607C171.423 37.9804 172.061 37.8048 172.364 37.3737C172.612 37.0145 172.62 36.4876 172.468 36.0725V36.0645Z",
    fill: "#F2AAA2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M173.578 38.6909C174.025 38.3397 174.647 38.2199 175.198 38.1481C175.501 38.1082 175.797 38.0762 176.1 38.0682C176.379 38.0523 176.675 38.0842 176.954 38.0523C177.018 38.0523 177.034 37.9645 176.97 37.9405C176.699 37.8527 176.363 37.8607 176.084 37.8687C175.757 37.8687 175.429 37.8926 175.102 37.9405C174.528 38.0363 173.913 38.188 173.45 38.5552C173.354 38.635 173.49 38.7628 173.586 38.6909H173.578Z",
    fill: "#E2967F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1866_503",
    x1: -4.13221,
    y1: 46.774,
    x2: 164.401,
    y2: 46.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1866_503",
    x1: -4.13221,
    y1: 46.774,
    x2: 164.401,
    y2: 46.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1866_503",
    x1: 19.3908,
    y1: 156.922,
    x2: 30.0891,
    y2: 156.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1866_503",
    x1: 218.186,
    y1: 156.922,
    x2: 228.874,
    y2: 156.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1866_503",
    x1: 147.851,
    y1: 174.856,
    x2: 173.477,
    y2: 174.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1866_503",
    x1: 195.928,
    y1: 174.856,
    x2: 221.554,
    y2: 174.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1866_503",
    x1: 180.401,
    y1: 174.864,
    x2: 191.447,
    y2: 174.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228829,
    stopColor: "#37C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560256,
    stopColor: "#8572DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF45EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1866_503",
    x1: 174.037,
    y1: 36.5441,
    x2: 174.464,
    y2: 32.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5AE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D0C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishImg);
export default __webpack_public_path__ + "static/media/finish-img.69d93a88e3a6861757182c442859ece6.svg";
export { ForwardRef as ReactComponent };